const messages = {
  en: {
    compararPreciosProveedor: {
      menuTitle: "Compare prices between suppliers",
      title: "Compare prices between suppliers",
      step1: "Configuration",
      step2Archivo: "Upload Excel",
      step2: "Analysis result",
      step3: "Confirmation",
      selectProveedor: "Supplier (price list source)",
      selectDeposito: "Warehouse",
      selectFile: "CSV/Excel file",
      tipoArchivo: "File type",
      tipoSimple: "Simple (supplier code, name, purchase price, discount)",
      tipoEstructurado: "Structured (supplier code, brand, model, size, other attributes, price, discount)",
      tipoSimpleDesc: "Columns: supplier code, product name, purchase price, supplier discount %.",
      tipoEstructuradoDesc:
        "Columns: supplier code, brand, model, size, other attributes, purchase price, supplier discount %.",
      descargarPlantilla: "Download template",
      downloadTemplateSimple: "Simple Template",
      downloadTemplateStructured: "Structured Template",
      hintConfig: "Select supplier and the import type according to your file format. The comparison uses your currently selected warehouse.",
      hintColumnasSimple:
        "Columns (same as product import, simple): supplier code (e.g. codigo_proveedor), name, purchase price, supplier discount %. Each row needs purchase price > 0 and supplier code and/or name.",
      hintColumnasEstructurado:
        "Columns (same as product import, structured): supplier code, brand, model, size, other attributes, purchase price, supplier discount %. At least one of brand, model or size; purchase price > 0.",
      hint: "Select the supplier whose price list you are importing, then upload a CSV or Excel with the same layout as product import for that mode (simple or structured).",
      procesarArchivo: "Process file",
      back: "Back",
      continuar: "Continue",
      colProducto: "Product",
      colExcel: "In file",
      colProductoDeposito: "Warehouse product",
      colCodigo: "Code",
      colPrecioActual: "Purchase price (current)",
      colDescuentoActual: "Current discount %",
      colPrecioVentaActual: "Current sale price",
      colPrecioNuevo: "New purchase price",
      colDescuentoNuevo: "New discount %",
      colPrecioVentaNuevo: "New sale price",
      colDiferencia: "Difference %",
      colCalculo: "Sale price calculation",
      colAccion: "Action",
      asociar: "Update price",
      ignorar: "Ignore",
      sinMatch: "No match",
      sinMatchSeleccionar: "No match – Select product",
      placeholderBuscarProducto: "Search product by name or code",
      resumenAsociar: "{n} product(s) will have price updated for this supplier.",
      confirmarTitulo: "Confirm",
      confirmarMensaje: "{n} product(s) will be updated. Confirm?",
      success: "Products updated successfully.",
      error: "Error updating products.",
      errorSeleccion: "Select supplier and file.",
      errorArchivoInvalido: "Select a valid file.",
      errorFilasVacias: "No valid rows found in the file.",
      errorProcesar: "Error processing file.",
      errorSinItems: "No items to apply.",
      errorSinDeposito: "You do not have a warehouse selected. Please select one in your user configuration or from the main menu.",
      noProductosMatcheados: "No products matched. Check file columns and that products exist in the system.",
      leyendaAsociar: "Update price — row will be updated with the new price.",
      leyendaIgnorar: "Ignore — row will not be applied.",
      leyendaPendiente: "No warehouse product yet — select a product or leave as is.",
      tooltipCalculoPrecios: "How sale prices are calculated (preview)",
      tooltipCalculoFila: "Show calculation breakdown for this row",
      modalCalculoTitulo: "Sale price calculation",
      modalCalculoSinProducto: "Select a warehouse product in this row to see the calculation.",
      modalCalculoSinPrecioCompra: "There is no valid purchase price to calculate.",
      modalConfigProductoTitulo: "Product settings (same for both columns)",
      modalConfigIva: "VAT",
      modalConfigMargen: "Margin on cost",
      modalConfigRedondeo: "Rounding type",
      modalConfigAyuda:
        "Below, each step applies these values to the list purchase price and supplier discount.",
      modalBloqueActual: "Current (system list)",
      modalBloqueNuevo: "New (imported list)",
      modalPasoPrecioCompra: "List purchase price",
      modalPasoDescuentoProveedor: "Supplier discount",
      modalPasoCostoNeto: "Net cost after discount",
      modalPasoIva: "VAT {n}% on net cost",
      modalPasoAplicarIva: "Apply VAT to net cost",
      modalPasoTrasIva: "Amount with VAT",
      modalPasoMargen: "Margin {n}% on amount with VAT",
      modalPasoAplicarMargen: "Apply margin to amount with VAT",
      modalPasoAntesRedondeo: "Price before rounding",
      modalPasoRedondeo: "Rounding",
      modalPasoAplicarRedondeo: "Apply rounding to price",
      modalPasoPrecioVentaFinal: "Calculated sale price",
      modalSinRedondeo: "None — two decimal places only",
      redondeoNinguno: "No rounding",
      redondeoCentavos: "Round up to whole pesos",
      redondeoMultiplo10: "Round up to multiple of 10",
      redondeoMultiplo100: "Round up to multiple of 100",
      modalNotaPrecioGuardado:
        "Sale price stored on the product: {monto}. It may differ if it was edited manually.",
      cerrar: "Close",
      // Mapping wizard
      allFieldsMapped: "All fields mapped. You can continue.",
      columnAlreadyMapped: "This column is already assigned to another field.",
      errorPrecioRequired: "Purchase price column is required.",
      errorIdentificadorRequired: "At least name or supplier code must be mapped.",
      errorIdentificadorEstructurado: "At least brand, model or size must be mapped.",
      fieldCodigoBarrasProveedor: "Supplier code",
      fieldNombre: "Name",
      fieldPrecioCompra: "Purchase price",
      fieldDescuentoProveedor: "Discount %",
      fieldMarca: "Brand",
      fieldModelo: "Model",
      fieldTamanio: "Size",
      fieldOtrasCaracteristicas: "Other attributes",
    },
  },
  es: {
    compararPreciosProveedor: {
      menuTitle: "Comparar precios entre proveedores",
      title: "Comparar precios entre proveedores",
      step1: "Configuración",
      step2Archivo: "Subir Excel",
      step2: "Resultado del análisis",
      step3: "Confirmación",
      selectProveedor: "Proveedor (origen de la lista)",
      selectDeposito: "Depósito",
      selectFile: "Archivo CSV/Excel",
      tipoArchivo: "Tipo de archivo",
      tipoSimple: "Simple (código proveedor, nombre, precio compra, descuento)",
      tipoEstructurado: "Estructurado (código, marca, modelo, tamaño, otras, precio, descuento)",
      tipoSimpleDesc: "Columnas: código del proveedor, nombre, precio de compra, descuento del proveedor (%).",
      tipoEstructuradoDesc:
        "Columnas: código del proveedor, marca, modelo, tamaño, otras características, precio de compra, descuento del proveedor (%).",
      descargarPlantilla: "Descargar plantilla",
      downloadTemplateSimple: "Plantilla Simple",
      downloadTemplateStructured: "Plantilla Estructurada",
      hintConfig: "Seleccione proveedor y el tipo de importación según el formato de su archivo. La comparación usa el depósito actualmente seleccionado en su usuario.",
      hintColumnasSimple:
        "Columnas (iguales que importar productos, simple): código del proveedor (ej. codigo_proveedor), nombre, precio de compra, descuento del proveedor (%). Cada fila: precio > 0 y código y/o nombre.",
      hintColumnasEstructurado:
        "Columnas (iguales que importar productos, estructurado): código del proveedor, marca, modelo, tamaño, otras características, precio de compra, descuento del proveedor (%). Al menos uno de marca, modelo o tamaño; precio > 0.",
      hint: "Seleccione el proveedor y suba un CSV/Excel con el mismo formato que en importar productos para ese modo (simple o estructurado).",
      procesarArchivo: "Procesar archivo",
      back: "Volver",
      continuar: "Continuar",
      colProducto: "Producto",
      colExcel: "En el archivo",
      colProductoDeposito: "Producto en depósito",
      colCodigo: "Código",
      colPrecioActual: "Precio de compra actual",
      colDescuentoActual: "Descuento actual %",
      colPrecioVentaActual: "Precio venta actual",
      colPrecioNuevo: "Precio de compra nuevo",
      colDescuentoNuevo: "Descuento nuevo %",
      colPrecioVentaNuevo: "Precio venta nuevo",
      colDiferencia: "Diferencia %",
      colCalculo: "Cálculo",
      colAccion: "Acción",
      asociar: "Actualizar precio",
      ignorar: "Ignorar",
      sinMatch: "Sin match",
      sinMatchSeleccionar: "Sin match – Seleccionar producto",
      placeholderBuscarProducto: "Buscar producto por nombre o código",
      resumenAsociar: "{n} producto(s) tendrán el precio actualizado para este proveedor.",
      confirmarTitulo: "Confirmar",
      confirmarMensaje: "Se actualizarán {n} producto(s). ¿Confirmar?",
      success: "Productos actualizados correctamente.",
      error: "Error al actualizar productos.",
      errorSeleccion: "Seleccione proveedor y archivo.",
      errorArchivoInvalido: "Seleccione un archivo válido.",
      errorFilasVacias: "No se encontraron filas válidas en el archivo.",
      errorProcesar: "Error al procesar el archivo.",
      errorSinItems: "No hay ítems para aplicar.",
      errorSinDeposito: "No tiene un depósito seleccionado. Seleccione uno en su configuración de usuario o desde el menú principal.",
      noProductosMatcheados: "No se encontraron productos. Verifique las columnas del archivo y que existan productos en el sistema.",
      leyendaAsociar: "Actualizar precio — la fila se actualizará con el precio de la lista.",
      leyendaIgnorar: "Ignorar — no se aplicará esta fila.",
      leyendaPendiente: "Sin producto en depósito — elija uno en la columna o déjela sin aplicar.",
      tooltipCalculoPrecios: "Cómo se calculan los precios de venta (vista previa)",
      tooltipCalculoFila: "Ver desglose de cálculo de esta fila",
      modalCalculoTitulo: "Cálculo de precios de venta",
      modalCalculoSinProducto: "Seleccione un producto en depósito en esta fila para ver el desglose.",
      modalCalculoSinPrecioCompra: "No hay un precio de compra válido para calcular.",
      modalConfigProductoTitulo: "Datos del producto (iguales en ambas columnas)",
      modalConfigIva: "IVA",
      modalConfigMargen: "Margen sobre costo",
      modalConfigRedondeo: "Tipo de redondeo",
      modalConfigAyuda:
        "Abajo, cada paso aplica estos valores sobre el precio de compra de lista y el descuento del proveedor.",
      modalBloqueActual: "Actual (lista en sistema)",
      modalBloqueNuevo: "Nuevo (lista importada)",
      modalPasoPrecioCompra: "Precio de compra de lista",
      modalPasoDescuentoProveedor: "Descuento del proveedor",
      modalPasoCostoNeto: "Costo neto tras descuento",
      modalPasoIva: "IVA {n}% sobre costo neto",
      modalPasoAplicarIva: "Aplicar IVA al costo neto",
      modalPasoTrasIva: "Importe con IVA",
      modalPasoMargen: "Margen {n}% sobre importe con IVA",
      modalPasoAplicarMargen: "Aplicar margen al importe con IVA",
      modalPasoAntesRedondeo: "Precio antes de redondear",
      modalPasoRedondeo: "Redondeo",
      modalPasoAplicarRedondeo: "Aplicar redondeo al precio",
      modalPasoPrecioVentaFinal: "Precio de venta calculado",
      modalSinRedondeo: "Ninguno — solo dos decimales",
      redondeoNinguno: "Sin redondeo",
      redondeoCentavos: "Redondear hacia arriba a pesos enteros",
      redondeoMultiplo10: "Redondear hacia arriba a múltiplo de 10",
      redondeoMultiplo100: "Redondear hacia arriba a múltiplo de 100",
      modalNotaPrecioGuardado:
        "Precio de venta guardado en el producto: {monto}. Puede diferir del calculado si se editó manualmente.",
      cerrar: "Cerrar",
      // Mapping wizard
      allFieldsMapped: "Todos los campos mapeados. Podés continuar.",
      columnAlreadyMapped: "Esta columna ya está asignada a otro campo.",
      errorPrecioRequired: "La columna de precio de compra es requerida.",
      errorIdentificadorRequired: "Al menos nombre o código del proveedor deben estar mapeados.",
      errorIdentificadorEstructurado: "Al menos marca, modelo o tamaño deben estar mapeados.",
      fieldCodigoBarrasProveedor: "Código del proveedor",
      fieldNombre: "Nombre",
      fieldPrecioCompra: "Precio compra",
      fieldDescuentoProveedor: "Descuento %",
      fieldMarca: "Marca",
      fieldModelo: "Modelo",
      fieldTamanio: "Tamaño",
      fieldOtrasCaracteristicas: "Otras características",
    },
  },
  pt: {
    compararPreciosProveedor: {
      menuTitle: "Comparar preços entre fornecedores",
      title: "Comparar preços entre fornecedores",
      step1: "Configuração",
      step2Archivo: "Enviar Excel",
      step2: "Resultado da análise",
      step3: "Confirmação",
      selectProveedor: "Fornecedor (origem da lista)",
      selectDeposito: "Depósito",
      selectFile: "Arquivo CSV/Excel",
      tipoArchivo: "Tipo de arquivo",
      tipoSimple: "Simples (código fornecedor, nome, preço compra, desconto)",
      tipoEstructurado: "Estruturado (código, marca, modelo, tamanho, outras, preço, desconto)",
      tipoSimpleDesc: "Colunas: código do fornecedor, nome, preço de compra, desconto do fornecedor (%).",
      tipoEstructuradoDesc:
        "Colunas: código do fornecedor, marca, modelo, tamanho, outras características, preço de compra, desconto do fornecedor (%).",
      descargarPlantilla: "Baixar modelo",
      downloadTemplateSimple: "Modelo Simples",
      downloadTemplateStructured: "Modelo Estruturado",
      hintConfig: "Selecione fornecedor e o tipo de importação conforme o formato do seu arquivo. A comparação usa o depósito atualmente selecionado no seu usuário.",
      hintColumnasSimple:
        "Colunas (iguais à importação de produtos, simples): código do fornecedor (ex. codigo_proveedor), nome, preço de compra, desconto do fornecedor (%). Cada linha: preço > 0 e código e/ou nome.",
      hintColumnasEstructurado:
        "Colunas (iguais à importação de produtos, estruturado): código do fornecedor, marca, modelo, tamanho, outras características, preço de compra, desconto do fornecedor (%). Pelo menos um de marca, modelo ou tamanho; preço > 0.",
      hint: "Selecione o fornecedor e envie CSV/Excel no mesmo formato da importação de produtos para esse modo (simples ou estruturado).",
      procesarArchivo: "Processar arquivo",
      back: "Voltar",
      continuar: "Continuar",
      colProducto: "Produto",
      colExcel: "No arquivo",
      colProductoDeposito: "Produto no depósito",
      colCodigo: "Código",
      colPrecioActual: "Preço de compra atual",
      colDescuentoActual: "Desconto atual %",
      colPrecioVentaActual: "Preço de venda atual",
      colPrecioNuevo: "Preço de compra novo",
      colDescuentoNuevo: "Desconto novo %",
      colPrecioVentaNuevo: "Preço de venda novo",
      colDiferencia: "Diferença %",
      colCalculo: "Cálculo",
      colAccion: "Ação",
      asociar: "Atualizar preço",
      ignorar: "Ignorar",
      sinMatch: "Sem correspondência",
      sinMatchSeleccionar: "Sem correspondência – Selecionar produto",
      placeholderBuscarProducto: "Buscar produto por nome ou código",
      resumenAsociar: "{n} produto(s) terão o preço atualizado para este fornecedor.",
      confirmarTitulo: "Confirmar",
      confirmarMensaje: "{n} produto(s) serão atualizados. Confirmar?",
      success: "Produtos atualizados com sucesso.",
      error: "Erro ao atualizar produtos.",
      errorSeleccion: "Selecione fornecedor e arquivo.",
      errorArchivoInvalido: "Selecione um arquivo válido.",
      errorFilasVacias: "Nenhuma linha válida encontrada no arquivo.",
      errorProcesar: "Erro ao processar o arquivo.",
      errorSinItems: "Nenhum item para aplicar.",
      errorSinDeposito: "Você não tem um depósito selecionado. Selecione um na configuração do usuário ou no menu principal.",
      noProductosMatcheados: "Nenhum produto encontrado. Verifique as colunas do arquivo e se existem produtos no sistema.",
      leyendaAsociar: "Atualizar preço — a linha será atualizada com o novo preço.",
      leyendaIgnorar: "Ignorar — esta linha não será aplicada.",
      leyendaPendiente: "Sem produto no depósito — selecione na coluna ou deixe sem aplicar.",
      tooltipCalculoPrecios: "Como os preços de venda são calculados (pré-visualização)",
      tooltipCalculoFila: "Ver detalhamento do cálculo desta linha",
      modalCalculoTitulo: "Cálculo dos preços de venda",
      modalCalculoSinProducto: "Selecione um produto no depósito nesta linha para ver o detalhamento.",
      modalCalculoSinPrecioCompra: "Não há preço de compra válido para calcular.",
      modalConfigProductoTitulo: "Dados do produto (iguais nas duas colunas)",
      modalConfigIva: "IVA",
      modalConfigMargen: "Margem sobre custo",
      modalConfigRedondeo: "Tipo de arredondamento",
      modalConfigAyuda:
        "Abaixo, cada etapa aplica esses valores ao preço de compra da lista e ao desconto do fornecedor.",
      modalBloqueActual: "Atual (lista no sistema)",
      modalBloqueNuevo: "Novo (lista importada)",
      modalPasoPrecioCompra: "Preço de compra da lista",
      modalPasoDescuentoProveedor: "Desconto do fornecedor",
      modalPasoCostoNeto: "Custo líquido após desconto",
      modalPasoIva: "IVA {n}% sobre custo líquido",
      modalPasoAplicarIva: "Aplicar IVA ao custo líquido",
      modalPasoTrasIva: "Valor com IVA",
      modalPasoMargen: "Margem {n}% sobre valor com IVA",
      modalPasoAplicarMargen: "Aplicar margem ao valor com IVA",
      modalPasoAntesRedondeo: "Preço antes do arredondamento",
      modalPasoRedondeo: "Arredondamento",
      modalPasoAplicarRedondeo: "Aplicar arredondamento ao preço",
      modalPasoPrecioVentaFinal: "Preço de venda calculado",
      modalSinRedondeo: "Nenhum — apenas duas casas decimais",
      redondeoNinguno: "Sem arredondamento",
      redondeoCentavos: "Arredondar para cima em pesos inteiros",
      redondeoMultiplo10: "Arredondar para cima em múltiplo de 10",
      redondeoMultiplo100: "Arredondar para cima em múltiplo de 100",
      modalNotaPrecioGuardado:
        "Preço de venda salvo no produto: {monto}. Pode diferir do calculado se foi editado manualmente.",
      cerrar: "Fechar",
      // Mapping wizard
      allFieldsMapped: "Todos os campos mapeados. Pode continuar.",
      columnAlreadyMapped: "Esta coluna já está atribuída a outro campo.",
      errorPrecioRequired: "A coluna de preço de compra é obrigatória.",
      errorIdentificadorRequired: "Pelo menos nome ou código do fornecedor devem ser mapeados.",
      errorIdentificadorEstructurado: "Pelo menos marca, modelo ou tamanho devem ser mapeados.",
      fieldCodigoBarrasProveedor: "Código do fornecedor",
      fieldNombre: "Nome",
      fieldPrecioCompra: "Preço de compra",
      fieldDescuentoProveedor: "Desconto %",
      fieldMarca: "Marca",
      fieldModelo: "Modelo",
      fieldTamanio: "Tamanho",
      fieldOtrasCaracteristicas: "Outras características",
    },
  },
};

export default messages;
